import ApiClient from './apiClient'
import {
  RequestGetRiskTimeline,
  ResponseGetRiskTimeline,
  ResponseGetRiskMembers,
  ResponseGetRiskTeams,
} from '../types/risk'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRiskTimeline = async (params: RequestGetRiskTimeline): Promise<any> => ApiClient.get(
  '/api/risk/timelines',
  (result: ResponseGetRiskTimeline) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRiskMembers = async (): Promise<any> => ApiClient.get(
  '/api/risk/members',
  (result: ResponseGetRiskMembers) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRiskTeams = async (): Promise<any> => ApiClient.get(
  '/api/risk/teams',
  (result: ResponseGetRiskTeams) => result,
)
